module.exports = __webpack_public_path__ + "static/media/DSC00011.55fa4440.jpg";